import { doRequest } from "utils/core";

const placeAPI = {
  getPlace: (params) => {
    const url = "api/place/index";
    return doRequest("get", url, { params });
  },
  getDetailPlace: (params) => {
    const url = "api/place/detail";
    return doRequest("get", url, { params });
  },
};

export default placeAPI;
